import { render, staticRenderFns } from "./OrderableProductConfigurable.vue?vue&type=template&id=6f64fe5e&"
import script from "./OrderableProductConfigurable.vue?vue&type=script&lang=ts&"
export * from "./OrderableProductConfigurable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports